import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

export default function FinalMessage() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <section ref={ref} className="relative py-40 px-6 bg-dark-800 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-64 h-64 bg-gold-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-gold-500 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-5xl mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={inView ? { opacity: 1, scale: 1 } : {}}
          transition={{ duration: 1 }}
        >
          {/* Decorative top line */}
          <div className="flex items-center justify-center gap-4 mb-12">
            <div className="w-24 h-px bg-gradient-to-r from-transparent to-gold-500"></div>
            <i className="ri-sparkling-2-fill text-3xl text-gold-400"></i>
            <div className="w-24 h-px bg-gradient-to-l from-transparent to-gold-500"></div>
          </div>

          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="font-serif text-5xl md:text-7xl text-gold-400 mb-8 leading-tight"
          >
            No pases la Cuaresma
            <br />
            <span className="text-warm-100">por encima.</span>
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="font-serif text-4xl md:text-5xl text-gold-300 italic"
          >
            Camínala por dentro.
          </motion.p>

          {/* Decorative bottom line */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={inView ? { opacity: 1 } : {}}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="flex items-center justify-center gap-4 mt-12"
          >
            <div className="w-24 h-px bg-gradient-to-r from-transparent to-gold-500"></div>
            <i className="ri-heart-3-fill text-3xl text-gold-400"></i>
            <div className="w-24 h-px bg-gradient-to-l from-transparent to-gold-500"></div>
          </motion.div>

          {/* Button to Music Page */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="mt-12"
          >
            <Link
              to="/musica"
              className="inline-flex items-center gap-3 px-8 py-4 bg-gold-500 text-dark-900 font-sans font-semibold text-base rounded-lg hover:bg-gold-400 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
            >
              <i className="ri-music-2-line text-2xl"></i>
              Escuchar "La Magdalena"
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}